module.exports = __webpack_public_path__ + "img/job_position.png";